import * as React from "react";
import TooltipContext from "./TooltipContext";
var useTooltip = function () {
    return React.useContext(TooltipContext);
};
export default useTooltip;
